import { render, staticRenderFns } from "./exam2.vue?vue&type=template&id=94bf5a34&scoped=true&"
import script from "./exam2.vue?vue&type=script&lang=js&"
export * from "./exam2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bf5a34",
  null
  
)

export default component.exports